import { useMemo } from 'react';
import type { StrategyFormState } from '../types/strategy';
import type { Province } from '../types/province';
import { projectState, type ProjectedState, type ProvinceSnapshot } from '../utils/strategyCalculations';

export function useStrategySimulation(
  formState: StrategyFormState | null,
  province: Province | null,
): ProjectedState | null {
  return useMemo(() => {
    if (!formState || !province) return null;

    const snapshot: ProvinceSnapshot = {
      totalLand: province.territory.totals.acres,
      population: province.population.total,
      race: province.metadata.race,
      honourTitle: province.metadata.title || 'PEASANT',
      alchemyBooks: province.sciences.books.ALCHEMY || 0,
    };

    return projectState(
      {
        buildings: formState.buildings,
        draftLevel: formState.draftLevel,
        draftRate: formState.draftRate,
        wageRate: formState.wageRate,
        scienceRate: formState.scienceRate,
        scienceAlloc: formState.scienceAlloc,
        armyComp: formState.armyComp,
        thiefPA: formState.thiefPA,
        wizardPA: formState.wizardPA,
      },
      snapshot,
    );
  }, [formState, province]);
}
